// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.FooterSkeleton-FooterSkeletonContainer-hQ67Y {
    background-color: var(--skeleton-tertiary-bg);
    padding-top: 90px;
}

.FooterSkeleton-footerSkeletonHeading1-iPHat,
.FooterSkeleton-footerSkeletonHeading2-mwIW2,
.FooterSkeleton-footerSkeletonHeading3-WaNJY {
    height: 28px;
    margin-bottom: 12px;
    border-radius: var(--radius-5);
    background-color: var(--skeleton-quaternary-bg);
}

.FooterSkeleton-footerSkeletonHeading1-iPHat {
    max-width: 99px;
}

.FooterSkeleton-footerSkeletonHeading2-mwIW2 {
    max-width: 82px;
}

.FooterSkeleton-footerSkeletonHeading3-WaNJY {
    max-width: 181px;
}

.FooterSkeleton-footerSkeletonWrapper-yWHdZ {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    -webkit-box-align: start;
        -ms-flex-align: start;
            align-items: flex-start;
}

.FooterSkeleton-footerSkeletonAboutList-cHzF3 {
    width: 100%;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
        -ms-flex-direction: column;
            flex-direction: column;
    gap: 6px;
}

.FooterSkeleton-footerSkeletonAboutListItem-IZvmc {
    height: 26px;
    border-radius: var(--radius-5);
    background-color: var(--skeleton-quaternary-bg);
}

.FooterSkeleton-footerSkeletonAboutListItem1-wq8qc {
    max-width: 55px;
}

.FooterSkeleton-footerSkeletonAboutListItem2-OS4g0 {
    max-width: 139px;
}

.FooterSkeleton-footerSkeletonAboutListItem3-KG_1Z {
    max-width: 121px;
}

.FooterSkeleton-footerSkeletonAboutListItem4-SgP2B {
    max-width: 78px;
}

.FooterSkeleton-footerSkeletonFollowUsList-jeAh_,
.FooterSkeleton-footerSkeletonPaymentList-Th7sl {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;

}

.FooterSkeleton-footerSkeletonFollowUsList-jeAh_ {
    gap: 18px;
}

.FooterSkeleton-footerSkeletonPaymentList-Th7sl {
    gap: 10px;
}

.FooterSkeleton-footerSkeletonFollowUsListItem-h7UzN {
    width: 19px;
    height: 19px;
    border-radius: var(--radius-1);
    background-color: var(--skeleton-quaternary-bg);
}

.FooterSkeleton-footerSkeletonPaymentListItem-UGIxT {
    width: 32px;
    height: 22px;
    border-radius: var(--radius);
    background-color: var(--skeleton-quaternary-bg);
}

.FooterSkeleton-copyRightSkeletonContainer-H3_Gn {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
        -ms-flex-align: center;
            align-items: center;
    -webkit-box-pack: center;
        -ms-flex-pack: center;
            justify-content: center;
    padding: 42px 0;
    margin-top: 42px;
    border-top: 1px solid var(--skeleton-quaternary-bg);
}

.FooterSkeleton-copyRightSkeletonDesc-oZOec {
    max-width: 306px;
    height: 24px;
    border-radius: var(--radius-5);
    background-color: var(--skeleton-quaternary-bg);
}

@media (max-width: 1199px) {
    .FooterSkeleton-FooterSkeletonRow-He5dR {
        row-gap: 24px;
    }
}

@media (max-width: 991px) and (max-width: 768px) {
    .FooterSkeleton-FooterSkeletonContainer-hQ67Y {
        padding-top: 60px;
    }
}

@media (max-width: 767px) {
    .FooterSkeleton-FooterSkeletonContainer-hQ67Y {
        padding-top: 48px;
    }

    .FooterSkeleton-footerSkeletonHeading1-iPHat,
    .FooterSkeleton-footerSkeletonHeading2-mwIW2,
    .FooterSkeleton-footerSkeletonHeading3-WaNJY {
        height: 26px;
        margin-bottom: 6px;
    }

    .FooterSkeleton-copyRightSkeletonContainer-H3_Gn {
        padding: 24px 0;
        margin-top: 24px;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/Skeleton/ViewBooking/FooterSkeleton/FooterSkeleton.css"],"names":[],"mappings":"AAAA;IACI,6CAA6C;IAC7C,iBAAiB;AACrB;;AAEA;;;IAGI,YAAY;IACZ,mBAAmB;IACnB,8BAA8B;IAC9B,+CAA+C;AACnD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,4BAAsB;IAAtB,6BAAsB;QAAtB,0BAAsB;YAAtB,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,+CAA+C;AACnD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;;AAEvB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,+CAA+C;AACnD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,4BAA4B;IAC5B,+CAA+C;AACnD;;AAEA;IACI,oBAAa;IAAb,oBAAa;IAAb,aAAa;IACb,yBAAmB;QAAnB,sBAAmB;YAAnB,mBAAmB;IACnB,wBAAuB;QAAvB,qBAAuB;YAAvB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,mDAAmD;AACvD;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,+CAA+C;AACnD;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;;;QAGI,YAAY;QACZ,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;AAEJ","sourcesContent":[".FooterSkeletonContainer {\n    background-color: var(--skeleton-tertiary-bg);\n    padding-top: 90px;\n}\n\n.footerSkeletonHeading1,\n.footerSkeletonHeading2,\n.footerSkeletonHeading3 {\n    height: 28px;\n    margin-bottom: 12px;\n    border-radius: var(--radius-5);\n    background-color: var(--skeleton-quaternary-bg);\n}\n\n.footerSkeletonHeading1 {\n    max-width: 99px;\n}\n\n.footerSkeletonHeading2 {\n    max-width: 82px;\n}\n\n.footerSkeletonHeading3 {\n    max-width: 181px;\n}\n\n.footerSkeletonWrapper {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n}\n\n.footerSkeletonAboutList {\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.footerSkeletonAboutListItem {\n    height: 26px;\n    border-radius: var(--radius-5);\n    background-color: var(--skeleton-quaternary-bg);\n}\n\n.footerSkeletonAboutListItem1 {\n    max-width: 55px;\n}\n\n.footerSkeletonAboutListItem2 {\n    max-width: 139px;\n}\n\n.footerSkeletonAboutListItem3 {\n    max-width: 121px;\n}\n\n.footerSkeletonAboutListItem4 {\n    max-width: 78px;\n}\n\n.footerSkeletonFollowUsList,\n.footerSkeletonPaymentList {\n    display: flex;\n    align-items: center;\n\n}\n\n.footerSkeletonFollowUsList {\n    gap: 18px;\n}\n\n.footerSkeletonPaymentList {\n    gap: 10px;\n}\n\n.footerSkeletonFollowUsListItem {\n    width: 19px;\n    height: 19px;\n    border-radius: var(--radius-1);\n    background-color: var(--skeleton-quaternary-bg);\n}\n\n.footerSkeletonPaymentListItem {\n    width: 32px;\n    height: 22px;\n    border-radius: var(--radius);\n    background-color: var(--skeleton-quaternary-bg);\n}\n\n.copyRightSkeletonContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 42px 0;\n    margin-top: 42px;\n    border-top: 1px solid var(--skeleton-quaternary-bg);\n}\n\n.copyRightSkeletonDesc {\n    max-width: 306px;\n    height: 24px;\n    border-radius: var(--radius-5);\n    background-color: var(--skeleton-quaternary-bg);\n}\n\n@media (max-width: 1199px) {\n    .FooterSkeletonRow {\n        row-gap: 24px;\n    }\n}\n\n@media (max-width: 991px) and (max-width: 768px) {\n    .FooterSkeletonContainer {\n        padding-top: 60px;\n    }\n}\n\n@media (max-width: 767px) {\n    .FooterSkeletonContainer {\n        padding-top: 48px;\n    }\n\n    .footerSkeletonHeading1,\n    .footerSkeletonHeading2,\n    .footerSkeletonHeading3 {\n        height: 26px;\n        margin-bottom: 6px;\n    }\n\n    .copyRightSkeletonContainer {\n        padding: 24px 0;\n        margin-top: 24px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"FooterSkeletonContainer": `FooterSkeleton-FooterSkeletonContainer-hQ67Y`,
	"footerSkeletonHeading1": `FooterSkeleton-footerSkeletonHeading1-iPHat`,
	"footerSkeletonHeading2": `FooterSkeleton-footerSkeletonHeading2-mwIW2`,
	"footerSkeletonHeading3": `FooterSkeleton-footerSkeletonHeading3-WaNJY`,
	"footerSkeletonWrapper": `FooterSkeleton-footerSkeletonWrapper-yWHdZ`,
	"footerSkeletonAboutList": `FooterSkeleton-footerSkeletonAboutList-cHzF3`,
	"footerSkeletonAboutListItem": `FooterSkeleton-footerSkeletonAboutListItem-IZvmc`,
	"footerSkeletonAboutListItem1": `FooterSkeleton-footerSkeletonAboutListItem1-wq8qc`,
	"footerSkeletonAboutListItem2": `FooterSkeleton-footerSkeletonAboutListItem2-OS4g0`,
	"footerSkeletonAboutListItem3": `FooterSkeleton-footerSkeletonAboutListItem3-KG_1Z`,
	"footerSkeletonAboutListItem4": `FooterSkeleton-footerSkeletonAboutListItem4-SgP2B`,
	"footerSkeletonFollowUsList": `FooterSkeleton-footerSkeletonFollowUsList-jeAh_`,
	"footerSkeletonPaymentList": `FooterSkeleton-footerSkeletonPaymentList-Th7sl`,
	"footerSkeletonFollowUsListItem": `FooterSkeleton-footerSkeletonFollowUsListItem-h7UzN`,
	"footerSkeletonPaymentListItem": `FooterSkeleton-footerSkeletonPaymentListItem-UGIxT`,
	"copyRightSkeletonContainer": `FooterSkeleton-copyRightSkeletonContainer-H3_Gn`,
	"copyRightSkeletonDesc": `FooterSkeleton-copyRightSkeletonDesc-oZOec`,
	"FooterSkeletonRow": `FooterSkeleton-FooterSkeletonRow-He5dR`
};
module.exports = ___CSS_LOADER_EXPORT___;
